/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { B100, N0, N10 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { Link } from '../../components/Router';

/**
 * A styled Link component has:
 * - a blue outline when focusing by Tab key
 * - And no outline when clicking on it.
 * "StyledOutlineLink" should have tabIndex=0 and direct child element has tabIndex=-1
 * Ref: https://stackoverflow.com/questions/31402576/enable-focus-only-on-keyboard-use-or-tab-press
 */
/**
 * @private
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledOutlineLink = styled(Link)`
	display: block;
	background-color: ${token('elevation.surface', N0)};
	border: none;
	padding: 0;

	&:hover {
		background-color: ${token('color.background.neutral.subtle.hovered', N10)};
		cursor: pointer;
		border-radius: ${token('border.radius.100', '3px')};
	}

	&:focus {
		background-color: ${token('color.background.neutral.subtle.hovered', N10)};
		outline: none;
		box-shadow: 0 0 0 2px ${token('color.border.focused', B100)};
		border-radius: ${token('border.radius.100', '3px')};
		transition: box-shadow 0.2s ease-in-out;
	}

	&:active {
		background-color: ${token('color.background.neutral.subtle.pressed', N10)};
	}

	// the directlly inner should have tabIndex=-1 so we don't want it be focusable.
	// Let outer element "StyledOutlineLink" (has tabIndex=0) can handle: has outline
	> *:focus {
		outline: none;
	}
`;
